import { configServices } from 'src/services';
import { currentOrigin } from 'src/app-config';
import { FC } from 'react';
import { hideLoadingModalReducer, setAlertResponse, showLoadingModalReducer } from 'src/store';
import { useDispatch } from 'react-redux';
import { useGetConfig, useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';

export const CartSettings: FC = () => {
    const config = useGetConfig();
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();
    //
    const rowStyles = { marginTop: '14px' };

    const setIsEnabledPublicPage = async () => {
        dispatch(showLoadingModalReducer());
        const response = await configServices.SetCartsIsEnabledPublicPage(!config.isEnabledCartsPublicPage);
        dispatch(hideLoadingModalReducer());
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
            return;
        }
        window.location.reload();
    }

    return (
        <div className={`container card ${isDarkMode ? 'bg-dark text-white' : ''} py-2 pb-3 mt-0`}>
            <div className={'row d-flex justify-content-start align-items-center'} style={rowStyles}>
                <div className={`${isMobile ? 'col-2' : 'col-3'} text-end`}>
                    <input type='checkbox'
                        className={'form-check-input checkbox-md pointer'}
                        checked={!!config.isEnabledCartsPublicPage}
                        onChange={setIsEnabledPublicPage}
                    />
                </div>
                <div className={'col'}>
                    <h5 className={`d-inline ${isDarkMode ? 'text-white' : ''} pt-2`}>
                        <span className={'c-pointer me-2'} onClick={setIsEnabledPublicPage}>
                            Habilitar página pública de Asignaciones
                        </span>
                        {config.isEnabledCartsPublicPage &&
                            <>
                            {isMobile && <br />}
                            (<a href={`${currentOrigin}/carritos/${config.congregation}`} target={'_blank'}>{`${currentOrigin}/carritos/${config.congregation}`}</a>)
                            </>
                        }
                    </h5>
                </div>
            </div>
        </div>
    );
}
